<template>
  <div class="d-flex header-wrapper">
    <div class="logo-container">
      <img class="logo" src="@/assets/logo.svg" />

      <div class="d-flex justify-center align-center d-sm-none">
        <div class="caption mr-1 font-weight-medium">{{ $t('program') }}:</div>
        <div class="caption">{{ program.defaultTitle }}</div>
      </div>
    </div>

    <div class="d-none d-sm-flex justify-center align-center">
      <div class="caption mr-1 font-weight-medium">{{ $t('program') }}:</div>
      <div class="caption">{{ program.defaultTitle }}</div>
    </div>
    
    <div class="buttons-container">
      <v-btn
        class="close-btn"
        small
        depressed
        color="error"
        @click="dialog = true"
      >
        <v-icon>mdi-phone-hangup</v-icon>
      </v-btn>

      <div class="primary px-2 d-flex align-center font-weight-medium">
        <div class="body-1 white--text">{{ duration | minuteSeconds }}</div>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="500">
      <div class="white pa-3">
        <div class="body-1 text-center mb-4">
          {{ $t('leavePresentation') }}
        </div>

        <div class="d-flex justify-center">
          <v-btn depressed color="error" class="mr-3" @click="onClose">{{ $t('leave') }}</v-btn>

          <v-btn color="primary" depressed @click="dialog = false">{{ $t('stay') }}</v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      duration: 0,
      interval: null,
      dialog: false,
    };
  },
  computed: {
    ...mapState({
      roomContent: (state) => state.guide.roomContent,
      roomCreatedAt: (state) => state.twilio.roomCreatedAt,
      program: (state) => state.guide.program,
    }),
  },
  created() {
    const countFrom = moment.utc(this.roomCreatedAt).toDate();

    const now = moment(new Date());

    this.duration = moment(now).diff(countFrom, "seconds");

    this.interval = setInterval(() => {
      this.duration++;
    }, 1000);
  },
  methods: {
    ...mapActions(["disconnect"]),
    onClose() {
      this.disconnect();

      this.$router.push({ path: "/" });
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
  .header-wrapper {
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    height: 48px;
  }

  .logo {
    height: 24px;
  }

  .close-btn {
    border-radius: 0 !important;
    height: 100% !important;
  }

  .program-info {
    border-left: 1px solid #e0e0e0;
  }

  .logo-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 8px;
  }

  .buttons-container {
    display: flex;
  }

  @media screen and (max-width: 600px) {
    .header-wrapper {
      height: auto;
    }

    .logo-container {
      flex-direction: column;
      align-items: flex-start;
      padding: 8px;
    }
  }
</style>